<template>
  <div ref="skillsSection" class="container-page py-10 md:py-14">
    <SectionHeading title="Skills" />

    <div class="grid gap-5 md:grid-cols-[1fr_1.3fr]">
      <div class="card p-6 sm:p-9">
        <h3 class="font-display text-[19px] font-semibold text-ink">Languages</h3>
        <ul class="mt-7 space-y-5">
          <li v-for="skill in skills" :key="skill.name">
            <div class="flex items-baseline justify-between text-[15px]">
              <span class="text-ink">{{ skill.name }}</span>
              <span class="text-[13px] text-muted">{{ skill.value }}%</span>
            </div>
            <div class="mt-2 h-2 w-full overflow-hidden rounded-full bg-surface-2">
              <div class="h-full rounded-full bg-accent transition-[width] duration-[1200ms] ease-out"
                :style="{ width: (visible ? skill.value : 0) + '%' }"></div>
            </div>
          </li>
        </ul>
      </div>

      <div class="card p-6 sm:p-9">
        <h3 class="font-display text-[19px] font-semibold text-ink">Frameworks &amp; Tools</h3>
        <ul class="mt-7 flex flex-wrap gap-2">
          <li v-for="tool in tools" :key="tool" class="chip !px-3.5 !py-1.5 !text-[14px]">{{ tool }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeading from '@/components/ui/SectionHeading.vue'

export default {
  components: { SectionHeading },

  data() {
    return {
      skills: [
        { name: 'Python', value: 75 },
        { name: 'Dart / Flutter', value: 75 },
        { name: 'SQL', value: 70 },
        { name: 'Vue.js', value: 65 },
        { name: 'JS / TS', value: 50 },
        { name: 'C / C++', value: 50 },
      ],
      tools: [
        'FastAPI',
        'Node.js & Express',
        'PostgreSQL',
        'MongoDB',
        'Redis',
        'Apache Kafka',
        'NATS JetStream',
        'MQTT & WebSockets',
        'Docker',
        'Kubernetes',
        'Helm & Terraform',
        'AWS',
        'GitHub Actions',
        'Prometheus & Grafana',
        'OpenTelemetry & Jaeger',
        'LangChain & OpenAI API',
        'Firebase Authentication',
        'Flutter',
        'Git',
      ],
      visible: false,
    };
  },

  mounted() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.visible = true;
          this.observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    this.observer.observe(this.$refs.skillsSection);
  },

  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },
};
</script>
